import { takeLatest, put } from 'redux-saga/effects';
import { TaskAPI } from 'api/tasks';
import { FetchStatus } from 'data/core';
import { updateDocTask } from 'data/documents';
import { saveTasks } from 'data/tasks/slice';
function* updateDocTaskManager(action) {
    const { payload } = action;
    const { projectId, taskId, partialTask, options } = payload;
    try {
        const response = yield TaskAPI.updateTask(projectId, taskId, partialTask);
        if (options === null || options === void 0 ? void 0 : options.resolveCallback) {
            options.resolveCallback(response);
        }
        yield put(saveTasks({
            data: [
                response
            ],
            fetchStatus: FetchStatus.Loaded
        }));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
    // TODO: handle error
    }
}
export const watchUpdateDocTasks = function*() {
    yield takeLatest(updateDocTask.type, updateDocTaskManager);
};
